import * as React from 'react';
import * as Sentry from '@sentry/react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from 'react-router';
import { shouldDropSentryEvent } from './sentry-filters';

const SENTRY_DSN = import.meta.env.SENTRY_DSN;

// For frontend apps, DSN presence is the standard "on/off" switch.
export const sentryEnabled = Boolean(SENTRY_DSN);

// Initialize once at module load (must be imported before app entry).
if (sentryEnabled) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        enableLogs: true,
        environment: import.meta.env.MODE,
        // Default: keep conservative sampling; override via server-side env if needed.
        tracesSampleRate: 0.1,
        beforeSend(event, hint) {
            if (shouldDropSentryEvent(event, hint)) {
                return null;
            }

            return event;
        },
    });
}
